// extracted by css-extract-rspack-plugin
export default {"ringLabels":"dsjLhs0aggjhdbkb"};